export default __webpack_public_path__ + "static/media/text-hierarchy-2.308af2d4.png";